import { render, staticRenderFns } from "./BannerInscrevase.vue?vue&type=template&id=048b7b0e&"
import script from "./BannerInscrevase.vue?vue&type=script&lang=js&"
export * from "./BannerInscrevase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports